import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2020-12-18 18:47:42
 * @LastEditTime: 2021-08-04 16:34:32
 * @LastEditors: wangshengqiang
 * @Description: 页面的跳转方法
 */
import { getQueryParam, getHashParam, toQueryString } from '@/utils/queryString.js';
import history from '@/history';
import { getPageNum } from '@/utils/utils';
export function getNext() {
  return +getPageNum() + 1;
}
export function getNextUrl(page) {
  const next = +page ? page : getNext();
  const currentUrl = window.location.href;
  const url = currentUrl.indexOf('#') === -1 ? `${currentUrl}#page=${next}` : currentUrl.replace(/#page=\d+/, `#page=${next}`);
  return url;
}
export function goNext(page, replace) {
  const next = +page !== undefined ? page : getNext();

  if (replace) {
    window.location.replace(`#page=${next}`);
  } else {
    window.location.hash = `#page=${next}`;
  }
}
export function jumpNext(page, replace) {
  const nextUrl = getNextUrl(page);

  if (replace) {
    history.replace(nextUrl);
  } else {
    history.push(nextUrl);
  }
}
export const jumpPage = (pageIndex, params = {}) => {
  const queryObj = getQueryParam();
  const hashObj = getHashParam();
  const queryStr = toQueryString(_objectSpread(_objectSpread({}, queryObj), params));
  hashObj.page = pageIndex;
  const hashStr = toQueryString(hashObj);
  const url = `/?${queryStr}#${hashStr}`;
  history.push(url);
};
export function goHome() {
  jumpNext(1);
}
export function goPrev() {
  window.history.back();
}